// ============================================================================
// DISJOINT SET UNION - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'disjoint-set-union',
  name: 'Disjoint Set Union',
  category: 'Data Structures',
  complexity: {
    time: 'O(α(N)) per operation (inverse Ackermann)',
    space: 'O(N)'
  },
  description: 'Also known as Union-Find, it maintains a collection of disjoint sets with efficient union and find operations. Uses path compression and union by rank to achieve nearly constant amortized time complexity.'
};
